import { render, staticRenderFns } from "./IconCheckbox.vue?vue&type=template&id=151ccee2&"
import script from "./IconCheckbox.vue?vue&type=script&lang=js&"
export * from "./IconCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('151ccee2')) {
      api.createRecord('151ccee2', component.options)
    } else {
      api.reload('151ccee2', component.options)
    }
    module.hot.accept("./IconCheckbox.vue?vue&type=template&id=151ccee2&", function () {
      api.rerender('151ccee2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Inputs/IconCheckbox.vue"
export default component.exports